import type { To } from "react-router";
import { toDetailStackPath } from "@/components/detail-stack";
import type { DetailStackEntry } from "@/components/detail-stack";

/**
 * The kinds of record the app opens in the detail stack, by the URL segment that names them.
 * Each has a drawer in detail.routes.tsx; no page route under a page that mounts the stack may use these names.
 */
export const DETAIL_KIND = {
  orders: "orders",
  customers: "customers",
  jobs: "jobs",
  run: "run",
} as const;

/** One of DETAIL_KIND's segments. */
export type DetailKind = (typeof DETAIL_KIND)[keyof typeof DETAIL_KIND];

/** The query string detail-stack links keep, read from window.location (the router's copy can be stale). */
export const getDetailSearch = (): string => {
  return window.location.search;
};

/** A link that opens `kind` (with its id, if it takes one) as the first drawer over `pagePath`, keeping the page's query string. */
export const toDetailLink = (pagePath: string, kind: DetailKind, id?: string): To => {
  const entry: DetailStackEntry<DetailKind> = { kind, id: id ?? null };
  return { pathname: toDetailStackPath(pagePath, [entry]), search: getDetailSearch() };
};
